import { ChapterPage } from './ChapterPage'
import { withChapterPage } from './withChapterPage'

const ConnectedChapterPage = withChapterPage(ChapterPage)

export { ConnectedChapterPage as ChapterPage }
